/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const challengeVsPairSchema = z.object({
  aSlug: z.string(),
  bSlug: z.string(),
  updatedAt: z.number(),
});

export type IChallengeVsPair = z.infer<typeof challengeVsPairSchema>;

export const listPublicChallengeVsV1ResultSchema = z.object({
  items: z.array(challengeVsPairSchema),
  nextCursor: z.string().nullable(),
});

export type IListPublicChallengeVsV1Result = z.infer<typeof listPublicChallengeVsV1ResultSchema>;

export const listPublicChallengeVsV1ResponseSchema = createApiResponseSchema(
  listPublicChallengeVsV1ResultSchema,
) as z.ZodSchema<IAPI<IListPublicChallengeVsV1Result>>;

export type IListPublicChallengeVsV1Response = IAPI<IListPublicChallengeVsV1Result>;
